<div class="width-stepper" [class.active]="active()">
    <button
        type="button"
        class="width-step"
        [disabled]="disabled() || value() <= min"
        [attr.aria-label]="'document.edit.imageCard.sizeDecrease' | translate"
        (click)="step(-1)">
        <ra-icon icon="minus" varColor="currentColor" [size]="14" />
    </button>
    <label class="width-field">
        <input
            type="text"
            inputmode="numeric"
            autocomplete="off"
            [value]="text()"
            [disabled]="disabled()"
            [attr.aria-label]="'document.edit.imageCard.sizeWidth' | translate"
            (input)="onInput($event)"
            (keydown)="onKeydown($event)"
            (blur)="onBlur()" />
        <span>%</span>
    </label>
    <button
        type="button"
        class="width-step"
        [disabled]="disabled() || value() >= 100"
        [attr.aria-label]="'document.edit.imageCard.sizeIncrease' | translate"
        (click)="step(1)">
        <ra-icon icon="add" varColor="currentColor" [size]="14" />
    </button>
</div>
